import type { SupportedLanguageCode, UserRole } from './shop';
import { API_BASE_URL } from '../config/api';

// Auth Request Types
export interface SignupRequest {
  username: string;
  fullname?: string;
  firstname?: string;
  lastname?: string;
  telephone: string;
  email: string;
  password: string;
  role?: UserRole | 'customer' | 'creator';
  profileImageUrl?: string;
  audienceProfile?: 'kid' | 'adult' | 'mixed';
  preferredLanguage?: SupportedLanguageCode;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface ForgotPasswordRequest {
  email: string;
  fullname?: string;
}

export interface ResetPasswordRequest {
  token?: string;
  code?: string;
  newPassword: string;
  email?: string;
}

export interface UpdateProfileRequest {
  fullname?: string;
  name?: string;
  firstname?: string;
  lastname?: string;
  telephone?: string;
  phone?: string;
  audienceProfile?: 'kid' | 'adult' | 'mixed';
  preferredLanguage?: SupportedLanguageCode;
  country?: string;
  dateOfBirth?: string;
  profileImageUrl?: string;
  file?: string;
  profile?: string;
  picture?: string;
  pictureFile?: string;
}

// Auth Response Types
export interface AuthResponse {
  success: boolean;
  message?: string;
  error?: string;
  user?: UserData;
  token?: string;
}

export interface UserData {
  id: string;
  username?: string;
  name: string;
  fullname?: string;
  email: string;
  role: UserRole | 'customer';
  provider?: 'email' | 'google' | 'apple';
  phone?: string;
  telephone?: string;
  country?: string;
  preferredLanguage?: SupportedLanguageCode;
  audienceProfile?: 'kid' | 'adult' | 'mixed';
  dateOfBirth?: string;
  profileImageUrl?: string;
}

export interface ApiError {
  success: boolean;
  message: string;
  error?: string;
}

// Auth Service Configuration
export interface AuthConfig {
  baseUrl: string;
  tokenKey: string;
  userKey: string;
}

export const defaultAuthConfig: AuthConfig = {
  baseUrl: API_BASE_URL,
  tokenKey: 'haapa.authToken',
  userKey: 'haapa.currentUser',
};
